import { render, staticRenderFns } from "./veracidade-fornecedor.vue?vue&type=template&id=4a01619a"
import script from "./veracidade-fornecedor.vue?vue&type=script&lang=js"
export * from "./veracidade-fornecedor.vue?vue&type=script&lang=js"
import style0 from "./veracidade-fornecedor.vue?vue&type=style&index=0&id=4a01619a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports